import { useHistory } from 'cross-platform/react-router';
import { refresh } from 'lib/router/utils/refresh';

export const useReloadHome = (): (() => void) => {
  const history = useHistory();
  return () => {
    refresh(history);
  };
};
